// extracted by mini-css-extract-plugin
export default {"cardLink":"TopicCard_cardLink__spC93","card":"TopicCard_card__KbFwl","icon":"TopicCard_icon__eeYbo","title":"TopicCard_title__gSeX0","description":"TopicCard_description__ry6xP"};